import { DateFilterItemsEnum } from './filter.enum';

export const InitialFilterDTO = {
  user: {
    name: '',
    value: null,
  },
  created: {
    name: '',
    value: null,
  },
  modified: {
    name: '',
    value: null,
  },
  sort: {
    name: '',
    value: '',
  },

  search: {
    name: '',
    value: '',
  },
};

// export const DateFilterItems = [
//   'All Time',
//   'Today',
//   'Yesterday',
//   'Last 7 days',
//   'Last 30 days',
//   'This year',
//   'Last year',
//   'Set a range',
// ];

export const DateFilterItems = [
  { name: 'All Time', value: DateFilterItemsEnum.All_TIME },
  { name: 'Today', value: DateFilterItemsEnum.TODAY },
  { name: 'This Week', value: DateFilterItemsEnum.WEEK },
  { name: 'This Month', value: DateFilterItemsEnum.MONTH },
];
